import { edmCampaign } from '@bingads-webui/edm-campaign';
import { AUTO_BIDDING_FEATURE_IDS } from '../constants';

const campaignEDM = edmCampaign.types.resolve('Model.Campaign');
const campaignResource = new campaignEDM.ResourceIdentifier();

const bulkEditCampaigns = (data) => {
  const createOrUpdateCall = campaignResource.bulkUpdate.bind(campaignResource);
  return createOrUpdateCall(data);
};

const getBiddingScheme = (coupon) => {
  switch (coupon.FeatureId) {
    case AUTO_BIDDING_FEATURE_IDS.MAX_CLICKS:
      return { Type: 'MaxClicks' };
    case AUTO_BIDDING_FEATURE_IDS.MAX_CONVERSIONS:
      return { Type: 'MaxConversions' };
    default:
      return null;
  }
};

export const useCampaigns = () => {
  const updateSelectedCampaigns = (selectedCampaigns, coupon) => {
    const biddingScheme = getBiddingScheme(coupon);
    const mtCampaignData = selectedCampaigns.map(camp => ({ Id: camp.id, BiddingScheme: biddingScheme }));
    return bulkEditCampaigns(mtCampaignData);
  };

  return ({
    updateSelectedCampaigns,
  });
};
